import { Component, OnInit } from '@angular/core';
import { IxellAPIService, IPlanningHisto, IPlanningRdvV1, StatusRDV } from '../../../tools/api.service';
import { ErrorService } from '../../../tools/error.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HeaderService } from '../../../tools/header.service';
import { Constants } from '../../../entities/Constants';
import { Language } from '../../../entities/Language';

@Component({
    selector: 'app-planning-history',
    templateUrl: './planning-history.component.html',
    styleUrls: ['./planning-history.component.scss']
})
export class PlanningHistoryComponent implements OnInit {

    private langue: Language;
    private langueSub: any;
    private historySub: any;
    private getStatusSub: any;
    private cancelSub: any;

    displayedColumns = ["rdvID", "statusRDV", "dateRDV", "duration", "typeIntervention", "user", "action"];
    planningSource: any;
    planningList: IPlanningHisto[] = [];
    planningFiltered: IPlanningHisto[] = [];
    actualFilterValue: number = 0;

    showCancelModal: boolean = false;
    currentRdv: IPlanningHisto = new IPlanningHisto();
    statusRDV: StatusRDV;

    constructor(private headerService: HeaderService, private api: IxellAPIService, private errorService: ErrorService, private _snackBar: MatSnackBar) { }


    ngOnInit() {
        this.headerService.changeTitle("support.supportAssistance");
        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);
        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            this.langue = langue;
        }, error => {
            console.log(error);
            if (this.langueSub != null) this.langueSub.unsubscribe();
        });

        this.getHisto(0);
    }

    getHisto(filterValue: number) {
        this.actualFilterValue = filterValue;
        this.planningList = [];
        this.historySub = this.api.allHistory(this.langue.toString()).subscribe(data => {

            console.log(data);

            if (data) {
                data.forEach(element => {

                    //element.rdv.startDate = new Date(element.rdv.startDate.setHours(element.rdv.startDate.getHours() - 2));

                    //element.date = new Date(element.date.setHours(element.date.getHours() - 2));

                    //var startDateUTC = new Date(Date.UTC(element.rdv.startDate.getFullYear(), element.rdv.startDate.getMonth(), element.rdv.startDate.getDate(), element.rdv.startDate.getHours(), element.rdv.startDate.getMinutes()));
                    //element.rdv.startDate = startDateUTC;
                    if (element.rdv.startDate > new Date() && element.rdv.status == 1 && element.rdv.wpRdvID != null) element.canCancel = true;
                    else element.canCancel = false;
                    if (filterValue == 0) {
                        if (element.rdv.startDate > new Date()) this.planningList.push(element);
                    }
                    else this.planningList.push(element);
                    this.planningSource = new MatTableDataSource(this.planningList);
                });
            }
            if (this.historySub != null) this.historySub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "allHistory", new Date().toString());
            if (this.historySub != null) this.historySub.unsubscribe();
        });
    }

    radioChange(value: number) {
        switch (value) {
            case 0: this.getHisto(0); break;
            case 1: this.getHisto(1); break;
        }
    }

    checkStatus(id: number) {
        this.statusRDV = 0;
        this.getStatusSub = this.api.getStatusRDV(id).subscribe(data => {
            this.statusRDV = data.valueOf();
            if (this.getStatusSub != null) this.getStatusSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getStatus", new Date().toString());
            if (this.getStatusSub != null) this.getStatusSub.unsubscribe();
        });
    }

    cancel(id: number) {
        this.checkStatus(id);

        window.setTimeout(() => {
            if (this.statusRDV != StatusRDV.TRANSMITTED) {
                this.getHisto(this.actualFilterValue);
            }
            else {
                this.currentRdv = new IPlanningHisto();
                this.currentRdv = this.planningList.find(r => r.rdv.rdvID == id)
                this.showCancelModal = true;
                this.openModal("cancelModal");
            }
        }, 700);
    }

    ValidCancel(res: boolean) {
        if (res == true) {
            this.closeModal("cancelModal");
            this.openModal("loadingModal");
            let token = this.currentRdv.rdv.wpRdvID;
            this.cancelSub = this.api.cancelRDV(this.currentRdv.rdv.rdvID, this.currentRdv.rdv.wpRdvID, null, null, null).subscribe(data => {
                if (data) {
                    this.getHisto(this.actualFilterValue);
                    window.setTimeout(() => { this.closeModal("loadingModal"); }, 500);
                }
                else {
                    this.closeModal("loadingModal");
                    this.openModal("errorModal");
                }
                if (this.cancelSub != null) this.cancelSub.unsubscribe();
            }, error => {
                this.closeModal("loadingModal");
                this.openModal("errorModal");
                this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "cancelRDV (planning-history)", new Date().toString());
                if (this.cancelSub != null) this.cancelSub.unsubscribe();
            });
        }
        else {
            this.closeModal("cancelModal");
        }
    }

    closeError() {
        this.getHisto(this.actualFilterValue);
        this.closeModal("errorModal");
    }

    closeModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "none";
    }

    openModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "block";
    }

    sortScale(sort: Sort, status: string) {
        var data = this.planningList;
        Constants.sortScale(sort, status, data);
        this.planningList = data.slice();
        this.planningSource = new MatTableDataSource(this.planningList);
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['blue-snackbar']
        });
    }
}
